export interface Document {
  id: number;
  fileName?: string | null;
  originalFileName?: string | null;
  supplierName?: string | null;
  customerName?: string | null;
  signed_original_url?: string;
  signed_url?: string;
}

export interface DownloadPayload {
  signed_url: string;
  filename: string;
}

export class DocumentDownloadService {
  
  private readonly allowedExtensions = [
    "pdf",
    "xls",
    "xlsx",
    "xlsm",
    "ods",
    "zip",
    "7z",
    "rar",
  ];

  public prepareDownload(doc: Document): DownloadPayload {
    const extension = this.extractExtension(doc);

    if (!this.allowedExtensions.includes(extension)) {
      throw new Error(`Unsupported file extension: .${extension}`);
    }

    return {
      signed_url: doc.signed_original_url || doc.signed_url || "",
      filename: this.generateFilename(doc),
    };
  }

  public generateFilename(doc: Document): string {
    const extension = this.extractExtension(doc);
    const baseName = this.extractBaseName(doc);
    return `doc_${doc.id}${baseName}.${extension}`;
  }

  private extractExtension(doc: Document): string {
    const fileNameExt = this.matchExtension(doc.fileName);
    if (fileNameExt) return fileNameExt;

    const originalExt = this.matchExtension(doc.originalFileName);
    if (originalExt) return originalExt;

    return "pdf";
  }

  private matchExtension(filename: string | null | undefined): string | null {
    if (!filename) return null;
    const match = filename.match(/\.([a-zA-Z0-9]{2,4})$/i);
    return match ? match[1].toLowerCase() : null;
  }

  private extractBaseName(doc: Document): string {
    let rawName = '';
    if (doc.supplierName) {
      rawName += '_'+doc.supplierName;
    }
    else if (doc.customerName) {
      rawName += '_'+doc.customerName;
    }
    if (doc.originalFileName) {
      rawName += '_'+doc.originalFileName;
    }

    const removeExtension = /\.[^/.]+$/;
    const replaceSpaces = / /g;
    const replaceSlash = '/';

    return rawName.replace(removeExtension, "").replace(replaceSpaces, "_").replace(replaceSlash, "_");
  }
}
